import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [showAuthModal, setShowAuthModal] = useState(false);

  useEffect(() => {
    const handleAuthError = () => {
      localStorage.removeItem('token');
      setIsAuthenticated(false);
      setShowAuthModal(true);
    };

    window.addEventListener('authError', handleAuthError);

    return () => {
      window.removeEventListener('authError', handleAuthError);
    };
  }, []);

  const login = (token) => {
    localStorage.setItem('token', token);
    setIsAuthenticated(true);
    setShowAuthModal(false);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setIsAuthenticated(false);
    setShowAuthModal(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, showAuthModal, setShowAuthModal, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};